import { gql } from '@apollo/client';

export const GET_REGISTER = gql`
    query register {
        register {
            __typename
            success
        }
    }
`;

export const GET_CLIENTS = gql`
    query getClients {
        getClients {
            __typename
            _id
            name
            time_zone
            currency
            legal_mailing_address
            campaign_type
        }
    }
`;

export const GET_CANADIAN_FEDERAL_ELECTIONS = gql`
    query getCanadianFederalElections {
        getCanadianFederalElections {
            __typename
            id
            title
            category
            year
            center
            bounds
            major_jurisdiction
            minor_jurisdiction
            district
            local_division
            added_date
            geojson_url
        }
    }
`;

export const GET_CANADIAN_FEDERAL_LEADERSHIPS = gql`
    query getCanadianFederalLeaderships {
        getCanadianFederalLeaderships {
            __typename
            id
            title
            category
            year
            center
            bounds
            major_jurisdiction
            minor_jurisdiction
            district
            local_division
            added_date
            geojson_url
            winner
        }
    }
`;

export const GET_CANADIAN_FEDERAL_LEADERSHIPS_PARTY = gql`
    query getCanadianFederalLeadershipsParty($minor_jurisdiction:String!) {
        getCanadianFederalLeadershipsParty(minor_jurisdiction:$minor_jurisdiction
        ) {
            __typename
            id
            title
            category
            year
            center
            bounds
            major_jurisdiction
            minor_jurisdiction
            district
            local_division
            added_date
            geojson_url
            winner
        }
    }
`;

export const GET_CANADIAN_FEDERAL_POLL_MAPS = gql`
    query getCanadianFederalPollMaps {
        getCanadianFederalElections {
            __typename
            _id
            district: String
            year: String
            minor_jurisdiction: String
            minor_jurisdiction: String
            event_type: String
            event: String
            year: String
            title: String
            local_division: String
            center:Float
        }
    }
`;

export const GET_ONE_FEDERAL_ELECTION_MAP = gql`
    query getCanadianFederalElection($year:String!) {
        getCanadianFederalElection(year:$year) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            bounds
            center
            geojson_url
            added_date
        }
    }
`;

export const GET_ONE_RIDING_INFO = gql`
    query getRidingInfo($year:String!,$local_division:String!,$event_type:String!,$event:String!,$major_jurisdiction:String!) {
        getRidingInfo(year:$year,local_division:$local_division,event_type:$event_type,event:$event,major_jurisdiction:$major_jurisdiction) {
            __typename
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            general_info
            general_news
            reviewed
        }
    }
`;

export const GET_ONE_CANADIAN_ELECTION_DETAILS = gql`
    query getCanadianElectionDetails($year:String!,$event_type:String!) {
        getCanadianElectionDetails(year:$year,event_type:$event_type) {
            __typename
        }
    }
`;

export const GET_ONE_PROVINCIAL_LEADERSHIP_MAP = gql`
    query getCanadianProvincialLeadership($minor_jurisdiction:String!,$year:String!,$district:String) {
        getCanadianProvincialLeadership(minor_jurisdiction:$minor_jurisdiction,year:$year,district:$district) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            district
            map_context
            bounds
            center
            geojson_url
            added_date
            government_type
        }
    }
`;

export const GET_ONE_PROVINCIAL_ELECTION_MAP = gql`
    query getCanadianProvincialElection($minor_jurisdiction:String!,$year:String!,$district:String) {
        getCanadianProvincialElection(minor_jurisdiction:$minor_jurisdiction,year:$year,district:$district) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            district
            map_context
            bounds
            center
            geojson_url
            added_date
            government_type
        }
    }
`;

export const GET_CANADIAN_PROVINCIAL_ELECTIONS = gql`
    query getCanadianProvincialElections($district:String!,$minor_jurisdiction:String!) {
        getCanadianProvincialElections(district:$district,minor_jurisdiction:$minor_jurisdiction) {
            __typename
            id
            title
            category
            year
            center
            bounds
            major_jurisdiction
            minor_jurisdiction
            district
            local_division
            added_date
            winner
            geojson_url
            government_type
        }
    }
`;

export const GET_ONE_CANADIAN_ELECTION = gql`
    query getOneCanadianElection($year:String!,$event_type:String!,$minor_jurisdiction:String!) {
        getOneCanadianElection(year:$year,event_type:$event_type,minor_jurisdiction:$minor_jurisdiction) {
            __typename
            year
            minor_jurisdiction
            major_jurisdiction
            government_type
            winner
            event_type
            district
            geojson_url
            event
            category
        }
    }
`;

export const GET_ALL_RELATED_CONTESTS = gql`
    query getAllRelatedContests($event_type:String!,$event:String!,$district:String!) {
        getAllRelatedContests(event_type:$event_type,event:$event,district:$district) {
            __typename
            year
            bounds
            center
            minor_jurisdiction
            major_jurisdiction
            event
            event_type
            local_division
            district
            map_context
            geojson_url
            category        
        }
    }



`;

export const GET_ONE_CANADIAN_ELECTION_CANDIDATES = gql`
    query getCanadianElectionRidingDetails($year:String!,$event_type:String!,$minor_jurisdiction:String,$local_division:String!) {
        getCanadianElectionRidingDetails(event_type:$event_type,year:$year,minor_jurisdiction:$minor_jurisdiction,local_division:$local_division) {
             __typename
            candidates {
                candidate_name
                candidate_party
                candidate_votes
                incumbent
                winner
                candidate_percent_of_vote
                contest_date
            }
        }
    }
`;

export const GET_ONE_FEDERAL_LEADERSHIP_MAP = gql`
    query getCanadianFederalLeadershipsPartyYear($year:String!,$minor_jurisdiction:String!) {
        getCanadianFederalLeadershipsPartyYear(year:$year,minor_jurisdiction:$minor_jurisdiction) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            bounds
            center
            geojson_url
            added_date
        }
    }
`;

export const GET_ONE_FEDERAL_POLL_MAP = gql`
    query getFederalPollMap($year:String!,$local_division:String!) {
        getFederalPollMap(year:$year,local_division:$local_division) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_ONE_PROVINCIAL_LEADERSHIP_POLL_MAP = gql`
    query getProvincialLeadershipPollMap($minor_jurisdiction:String!,$year:String!,$local_division:String!) {
        getProvincialLeadershipPollMap(minor_jurisdiction:$minor_jurisdiction,year:$year,local_division:$local_division) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_ONE_PROVINCIAL_POLL_MAP = gql`
    query getProvincialPollMap($minor_jurisdiction:String!,$year:String!,$local_division:String!) {
        getProvincialPollMap(minor_jurisdiction:$minor_jurisdiction,year:$year,local_division:$local_division) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const SEARCH_FEDERAL_POLL_MAPS = gql`
    query findFederalPollMaps($district:String!) {
        findFederalPollMaps(district:$district) {
            maps {
                __typename
                title
                category
                year
                event
                event_type
                major_jurisdiction
                minor_jurisdiction
                local_division
                district
                bounds
                center
                geojson_url
                added_date
                winner
            }
            candidates {
                year
                event
                event_type
                major_jurisdiction
                minor_jurisdiction
                local_division
                district
                candidate_name
                candidate_photo
                candidate_twitter
                candidate_party
                candidate_party_code
                candidate_votes
                candidate_percent_of_vote
                incumbent
                winner
            }
        }
    }
`;

export const SEARCH_PROVINCIAL_POLL_MAPS = gql`
    query findProvincialPollMaps($district:String!,$minor_jurisdiction:String!) {
        findProvincialPollMaps(district:$district,minor_jurisdiction:$minor_jurisdiction) {
            maps {
                __typename
                title
                category
                year
                event
                event_type
                major_jurisdiction
                minor_jurisdiction
                local_division
                district
                bounds
                center
                geojson_url
                added_date
                winner
            }
            candidates {
                year
                event
                event_type
                major_jurisdiction
                minor_jurisdiction
                local_division
                district
                candidate_name
                candidate_photo
                candidate_twitter
                candidate_party
                candidate_party_code
                candidate_votes
                candidate_percent_of_vote
                incumbent
                winner
            }
        }
    }
`;

export const GET_NEARBY_FEDERAL_POLL_MAPS_SAME_YEAR = gql`
    query getFederalPollMapsNearYear($local_division:String!,$year:String!,$lng:Float!,$lat:Float!) {
        getFederalPollMapsNearYear(local_division:$local_division,year:$year,lng:$lng,lat:$lat) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_NEARBY_PROVINCIAL_POLL_MAPS_SAME_YEAR = gql`
    query getProvincialPollMapsNearYear($local_division:String!,$year:String!,$lng:Float!,$lat:Float!,$major_jurisdiction:String!,$minor_jurisdiction:String!) {
        getProvincialPollMapsNearYear(local_division:$local_division,year:$year,lng:$lng,lat:$lat,major_jurisdiction:$major_jurisdiction,minor_jurisdiction:$minor_jurisdiction) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_NEARBY_POLL_MAPS_SAME_YEAR = gql`
    query getPollMapsNearYear($event_type:String!,$local_division:String!,$year:String!,$lng:Float!,$lat:Float!,$major_jurisdiction:String!,$minor_jurisdiction:String!) {
        getPollMapsNearYear(event_type:$event_type,local_division:$local_division,year:$year,lng:$lng,lat:$lat,major_jurisdiction:$major_jurisdiction,minor_jurisdiction:$minor_jurisdiction) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_NEARBY_FEDERAL_POLL_MAPS_HISTORY = gql`
    query getFederalPollMapsNearHistory($year:String!,$lng:Float!,$lat:Float!) {
        getFederalPollMapsNearHistory(year:$year,lng:$lng,lat:$lat) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_NEARBY_POLL_MAPS_HISTORY = gql`
    query getPollMapsNearHistory($event_type:String!,$local_division:String!,$year:String!,$lng:Float!,$lat:Float!,$major_jurisdiction:String!,$minor_jurisdiction:String!) {
        getPollMapsNearHistory(event_type:$event_type,local_division:$local_division,year:$year,lng:$lng,lat:$lat,major_jurisdiction:$major_jurisdiction,minor_jurisdiction:$minor_jurisdiction) {
            __typename
            title
            category
            year
            event
            event_type
            major_jurisdiction
            minor_jurisdiction
            local_division
            district
            bounds
            center
            geojson_url
            added_date
            winner
        }
    }
`;

export const GET_ONE_FEDERAL_POPULATION_PYRAMID = gql`
    query getFederalPopulation($local_division:String!) {
        getFederalPopulation(local_division:$local_division) {
            __typename
            age
            male
            female
        }
    }
`;

export const GET_ONE_FEDERAL_POPULATION_PYRAMID_PROVINCE = gql`
    query getFederalPopulationProvince($province_id:String!) {
        getFederalPopulationProvince(province_id:$province_id) {
            __typename
            age
            male
            female
        }
    }
`;

export const GET_ONE_FEDERAL_POPULATION_PYRAMID_CANADA = gql`
    query getFederalPopulationCanada($country:String!) {
        getFederalPopulationCanada(country:$country) {
            __typename
            age
            male
            female
        }
    }
`;

export const GET_ONE_FEDERAL_EDUCATION_DATA = gql`
    query getFederalEducation($local_division:String!) {
        getFederalEducation(local_division:$local_division) {
            __typename
            name
            value
        }
    }
`;

export const GET_ONE_FEDERAL_RESIDENCE_DATA = gql`
query getFederalResidence($local_division:String!) {
    getFederalResidence(local_division:$local_division) {
        __typename
        name
        value
    }
}
`;

export const GET_ONE_FEDERAL_RESIDENCE_DATA_PROVINCE = gql`
query getFederalResidenceProvince($province_id:String!) {
    getFederalResidenceProvince(province_id:$province_id) {
        __typename
        name
        value
    }
}
`;

export const GET_ONE_FEDERAL_RESIDENCE_DATA_CANADA = gql`
query getFederalResidenceCanada($country:String!) {
    getFederalResidenceCanada(country:$country) {
        __typename
        name
        value
    }
}
`;

export const GET_ONE_FEDERAL_INCOME_DATA = gql`
query getFederalIncome($local_division:String!) {
    getFederalIncome(local_division:$local_division) {
        __typename
        name
        value
    }
}
`;

export const GET_ONE_FEDERAL_INCOME_DATA_PROVINCE = gql`
query getFederalIncomeProvince($province_id:String!) {
    getFederalIncomeProvince(province_id:$province_id) {
        __typename
        name
        value
        hid
    }
}
`;

export const GET_ONE_FEDERAL_INCOME_DATA_CANADA = gql`
query getFederalIncomeCanada($country:String!) {
    getFederalIncomeCanada(country:$country) {
        __typename
        name
        value
        hid
    }
}
`;

export const SEARCH_TWITTER_SPACES = gql`
query getTwitterSpaces($search:String!) {
    getTwitterSpaces(search:$search) {
        __typename
        spaces {
            id
            updated_at
            creator_id
            creator {
              id
              name
              username
              profile_image_url
              verified
              description
              location
              public_metrics {
                followers_count
                following_count
                tweet_count
                listed_count
              }
            }
            hosts {
              id
              name
              username
              profile_image_url
              verified
              description
              location
              public_metrics {
                followers_count
                following_count
                tweet_count
                listed_count
              }              
            }
            speakers {
              id
              name
              username
              profile_image_url
              verified
              description
              location
              public_metrics {
                followers_count
                following_count
                tweet_count
                listed_count
              }              
            }
            invited_users {
              id
              name
              username
              profile_image_url
              verified
              description
              location
              public_metrics {
                followers_count
                following_count
                tweet_count
                listed_count
              }                            
            } 
            topic_ids
            topics {
              id
              name
              description
            }  
            scheduled_start
            title
            created_at
            lang
            host_ids
            state
            participant_count
            started_at
        }
    }
}
`;